jQuery(document).ready(function($) {
  // Get all cards and houses
  const $cards = $('.indy-block-hero-animation .referenz-card');
  const $houses = $('.indy-block-hero-animation .house');

  if ($cards.length === 0 || $houses.length === 0) return;

  const numReferenzen = $cards.length;

  // Check if mobile (matches lg breakpoint - 992px)
  function isMobile() {
    return window.innerWidth < 992;
  }

  // Shuffle array helper - create shuffled indices
  function createShuffledIndices(length) {
    const indices = Array.from({ length: length }, (_, i) => i);
    for (let i = indices.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [indices[i], indices[j]] = [indices[j], indices[i]];
    }
    return indices;
  }

  // Create shuffled mapping of referenzen indices
  const shuffledIndices = createShuffledIndices(numReferenzen);

  // Assign referenz index to each house (cycling if more houses than referenzen)
  const houseReferenzMap = [];
  $houses.each(function(index) {
    houseReferenzMap.push(shuffledIndices[index % numReferenzen]);
  });

  // Function to show a specific card and activate house
  function showCard($card, $house) {
    // Remove show class from all cards
    $cards.removeClass('show');

    // Remove active class from all houses
    $houses.removeClass('active');

    // Add show class to the selected card
    $card.addClass('show');

    // Add active class to the house
    if ($house) {
      $house.addClass('active');
    }
  }

  // Add hover listeners to each house
  $houses.each(function(index) {
    const $house = $(this);
    const referenzIndex = houseReferenzMap[index];
    const $card = $cards.eq(referenzIndex);

    $house.css('cursor', 'pointer');

    // Mouse enter handler - show card on hover
    $house.on('mouseenter', function() {
      showCard($card, $house);
    });
  });

  // Click outside handler to hide cards
  $(document).on('click', function(e) {
    const $target = $(e.target);
    const isHouse = $target.closest('.house').length > 0;
    const isCard = $target.closest('.referenz-card').length > 0;

    // If clicking outside both house and card, hide all cards
    if (!isHouse && !isCard) {
      $cards.removeClass('show');
      $houses.removeClass('active');
    }
  });

  // Initially show placeholder and real card (only on desktop)
  if (!isMobile()) {
    const $placeholder = $('.referenz-cards-placeholder');
    const initialHouseId = '#ew1DyglG95S255'; // Change this to desired initial house ID
    const $initialHouse = $houses.filter(initialHouseId);

    // Show placeholder immediately
    $placeholder.addClass('show');

    if ($initialHouse.length > 0) {
      const initialHouseIndex = $houses.index($initialHouse);
      const initialReferenzIndex = houseReferenzMap[initialHouseIndex];
      const $initialCard = $cards.eq(initialReferenzIndex);

      // After 1 second, hide placeholder and show real card
      setTimeout(function() {
        $placeholder.removeClass('show');
        showCard($initialCard, $initialHouse);
      }, 2000);
    }
  }

});
